import React from 'react';
import { Group, Line } from 'react-konva';
import type { TrackDirection } from '../../utils/topology';

type TrackDirectionMarkerProps = {
  x: number;
  y: number;
  rotation?: number;
  direction: TrackDirection;
  zoomLevel: number;
  color?: string;
  /** Multiplier on the base marker size (curves use a much smaller arrow). */
  sizeScale?: number;
};

const TrackDirectionMarker: React.FC<TrackDirectionMarkerProps> = ({
  x,
  y,
  rotation = 0,
  direction,
  zoomLevel,
  color = '#cccccc',
  sizeScale = 1,
}) => {
  const scale = Math.max(0.05, sizeScale);
  // Keep the original straight-track size; curves pass a small sizeScale.
  const markerSize = Math.max(2, 5 / Math.max(zoomLevel, 0.05)) * scale;
  const halfHeight = markerSize / 2;
  const halfGap = (0.75 / Math.max(zoomLevel, 0.05)) * scale;
  const triangleProps = {
    closed: true,
    fill: color,
    listening: false,
    perfectDrawEnabled: false,
  } as const;

  return (
    <Group x={x} y={y} rotation={rotation} listening={false}>
      {direction === 'bi' && (
        <Line
          points={[-markerSize - halfGap, 0, -halfGap, -halfHeight, -halfGap, halfHeight]}
          {...triangleProps}
        />
      )}
      <Line
        points={
          direction === 'bi'
            ? [markerSize + halfGap, 0, halfGap, -halfHeight, halfGap, halfHeight]
            : [markerSize / 2, 0, -markerSize / 2, -halfHeight, -markerSize / 2, halfHeight]
        }
        {...triangleProps}
      />
    </Group>
  );
};

export default TrackDirectionMarker;
